// removed by extract-text-webpack-plugin
module.exports = {"box":"Box-box-2Fzcb"};


//////////////////
// WEBPACK FOOTER
// ./modules/issFrontend/styles/Box.styl
// module id = ./modules/issFrontend/styles/Box.styl
// module chunks = 1